export default function() {
  const widgetName = 'cardWidgetEvents';
  const widgetOpts = cardWidgetEventsOpts;

  function formatDate(dateString) {
    // separate dates from year
    const date = dateString.split(",")[0];
    // check if date is a range
    if (date.includes(" - ")) {
      // return the range as is
      return date;
    }
    // if not a range, return the date
    return date;
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      $(`#${widgetName} .card-widget-item`).each(function(i, item) {
        if (data.items[i].DateRange) {
          const formattedDate = formatDate(data.items[i].DateRange);
          $(this).prepend(`
            <div class="card-widget-date">
              ${formattedDate}
            </div>
          `);
        }
      });

      // Add the link dynamically
      var $container = $(`#${widgetName}`);
      var $link = $('<a>', {
        href: 'https://www.josephinecountyfairgrounds.com/events',
        class: 'all-events-link',
        'aria-label': 'See All Events',
        text: 'See All Events >'
      });
      $container.append($link);
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: true
  });
}